import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/user-check-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M1.00009 21C1.00009 19.6774 0.988894 18.7943 1.21493 18.0488C1.69969 16.4508 2.95092 15.1996 4.54892 14.7148C5.29437 14.4888 6.1775 14.5 7.50009 14.5H12.0001C12.5524 14.5 13.0001 14.9477 13.0001 15.5C13.0001 16.0523 12.5524 16.5 12.0001 16.5H7.50009C6.03177 16.5 5.51906 16.5106 5.129 16.6289C4.17031 16.9198 3.41986 17.6702 3.129 18.6289C3.01067 19.019 3.00009 19.5317 3.00009 21C3.00009 21.5523 2.55238 22 2.00009 22C1.44781 22 1.00009 21.5523 1.00009 21ZM21.2931 15.293C21.6836 14.9024 22.3166 14.9024 22.7071 15.293C23.0976 15.6835 23.0976 16.3165 22.7071 16.707L18.7071 20.707C18.3166 21.0976 17.6836 21.0976 17.2931 20.707L15.2931 18.707L15.2247 18.6309C14.9043 18.2381 14.9269 17.6591 15.2931 17.293C15.6592 16.9269 16.2382 16.9043 16.6309 17.2246L16.7071 17.293L18.0001 18.5859L21.2931 15.293ZM13.5001 7.5C13.5001 5.567 11.9331 4 10.0001 4C8.06709 4 6.50009 5.567 6.50009 7.5C6.50009 9.433 8.06709 11 10.0001 11C11.9331 11 13.5001 9.433 13.5001 7.5ZM15.5001 7.5C15.5001 10.5376 13.0377 13 10.0001 13C6.96252 13 4.50009 10.5376 4.50009 7.5C4.50009 4.46243 6.96252 2 10.0001 2C13.0377 2 15.5001 4.46243 15.5001 7.5Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as UserCheck01Icon };
